import React from 'react';
import { Button } from 'atoms/Button';
import { Box, Modal } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  'min-width': 400,
  'max-width': '50%',
  bgcolor: 'var(--c-background2)',
  borderRadius: '10px',
  p: 4,
  border: '1px solid var(--c-primary-color)',
  height: '30rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  'padding-bottom': '64px',
};
interface MessageModalProps {
  message: string;
  linkList?: JSX.Element[];
  closeLabel: string;
  onClose: () => void;
}

const MessageModal: React.FC<MessageModalProps> = ({ message, linkList, closeLabel, onClose }) => {
  return (
    <Modal
      open={true}
      onClose={onClose}
      role="dialog"
      aria-describedby="modal-modal-description"
      aria-labelledby="modal-modal-title"
    >
      <Box sx={style}>
        <h2 id="modal-modal-title" className="sr-only">
          {message}
        </h2>
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            flexDirection: 'column',
          }}
        >
          <p id="modal-modal-description" className="text-center whitespace-pre-wrap">
            {message}
          </p>
          {linkList && (
            <div className="flex flex-col overflow-auto mt-5 mb-5">
              {linkList.map((link) => link)}
            </div>
          )}
        </div>
        <div className={'flex justify-center w-full mb-auto'}>
          <Button label={closeLabel} onClick={onClose} />
        </div>
      </Box>
    </Modal>
  );
};
export default MessageModal;
